export default __webpack_public_path__ + "static/media/play.8e5f6d1d.mp3";